import { render, staticRenderFns } from "./TableItem.vue?vue&type=template&id=80b79fee&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"
import style0 from "./TableItem.vue?vue&type=style&index=0&id=80b79fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b79fee",
  null
  
)

export default component.exports